import { IS_CLIENT } from './checkRenderEnv';

/**
 * Determines whether robots (web crawlers) should be blocked based on the current hostname.
 *
 * @returns {boolean} Returns `true` if the current hostname matches any of the blocked domains, otherwise `false`.
 */

export function shouldBlockRobots(hostname = '') {
  if (!hostname && IS_CLIENT) {
    hostname = window?.location?.hostname;
  }
  const blockedDomains = [
    'showroom.dotpe.in',
    // Add more if needed
  ];

  return blockedDomains?.some(
    (domain) => hostname === domain || hostname.endsWith(`.${domain}`)
  );
}
